import React from "react";
import PropTypes from "prop-types";

const Layers = ({ children }) => <div>{children}</div>;
Layers.propTypes = {
  children: PropTypes.node.isRequired,
};
export default Layers;
